// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    fill='var(--icon-fill-color, currentColor)'
    stroke='var(--icon-stroke-color, currentColor)'
    stroke-linecap='round'
    stroke-linejoin='round'
    stroke-width='2'
    class='lucide lucide-star'
    viewBox='0 0 24 24'
    ...attributes
  ><path d='M12 17.8 5.8 21 7 14.1 2 9.3l7-1L12 2' /><path
      fill='none'
      d='m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z'
    /></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'StarHalfFill';
export default IconComponent;
